import { render, staticRenderFns } from "./SelecionarLaudo.vue?vue&type=template&id=5bc498eb&scoped=true&lang=pug"
import script from "./SelecionarLaudo.vue?vue&type=script&lang=js"
export * from "./SelecionarLaudo.vue?vue&type=script&lang=js"
import style0 from "./SelecionarLaudo.vue?vue&type=style&index=0&id=5bc498eb&prod&scoped=true&lang=scss"
import style1 from "./SelecionarLaudo.vue?vue&type=style&index=1&id=5bc498eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc498eb",
  null
  
)

export default component.exports